import React from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { asPercentageString, asPercentageStringDecimal } from "../../utils/formatters";
import AnimatedNumber from "react-animated-number";
import ReactTooltip from "react-tooltip";

function PercentageDisplay(props) {
  props = {
    size: 46,
    showDecimal: false,
    disableAnimation: false,
    color: "#4a9bff",
    toFixedValue: null,
    toolTipId: "percentageDisplay",
    ...props
  };
  const style = {
    margin: 0,
    padding: 0,
    display: "inline",
    fontWeight: "100",
    transition: "0.8s ease-out", fontSize: props.size,
    color: props.color
  };

  const formatValue = n=> props.showDecimal ? asPercentageStringDecimal(n, props.toFixedValue) : asPercentageString(n, props.value)
  const animatedProps = {
    component: "h5",
    value: 0 || +props.value,
    initialValue: props.disableAnimation ? +props.value : 0,
    style,
    className: "moneyDisplay",
    duration: 1000,
    stepPrecision: 0,
    formatValue
  };
  return (
    <span data-tip={props.toolTipContent} data-for={props.toolTipId} style={{display: "inline-block"}}>
      {props.url ? (
        <a style={styles.cta} href={props.url} target="_raw_data_tab">
          <span>
            <AnimatedNumber {...animatedProps}/>
          </span>
        </a>
      ) : <AnimatedNumber {...animatedProps}/>
      }
      <ReactTooltip id={props.toolTipId} html />
    </span>
  );
}

PercentageDisplay.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.number,
  color: PropTypes.string,
  url: PropTypes.string,
  showDecimal: PropTypes.bool,
  toFixedValue: PropTypes.number,
  toolTipContent: PropTypes.string,
  toolTipId: PropTypes.string,
  disableAnimation: PropTypes.bool
};

let styles = {
  cta: {
    textDecoration: "none"
  }
};

export default Radium(PercentageDisplay);
